import cookies from 'browser-cookies'
import { Connectors, WalletProviderType } from '../../lib/wagmi/connectors'
import { deleteCookie } from '../core/Utils'

/**
 * This hook is a temporary fix for the web3Context not persisting across our various
 * app entry points (app, landing, internal, player).
 *
 * For now we are storing the walletType in a cookie and using that connect to the correct
 * eth client whenever we lose the web3 context state
 */
export const getLastWalletConnector = () => {
  const walletProvider = cookies.get('walletProvider') as WalletProviderType | 'unknown'

  if (walletProvider == null || walletProvider === 'unknown') {
    deleteCookie('session')

    return undefined
  }

  try {
    return Connectors[walletProvider]
  } catch {
    return undefined
  }
}
